import { OrganizationKeyName } from "../../../model/Organization";

export const SET_IS_VISIBLE_NEW_HOMEPAGE_CONFIG =
  "SHOP:SET_IS_VISIBLE_NEW_HOMEPAGE_CONFIG";

export const setIsVisibleNewHomepageConfig = (
  organization: OrganizationKeyName,
  isVisible: boolean
) => ({
  type: SET_IS_VISIBLE_NEW_HOMEPAGE_CONFIG as typeof SET_IS_VISIBLE_NEW_HOMEPAGE_CONFIG,
  organization,
  isVisible,
});

export type SetIsVisibleNewHomepageConfig = ReturnType<
  typeof setIsVisibleNewHomepageConfig
>;
